// 其他属性默认值
export const defaultOtherInfo = {
    '1687': {
        property_name: '品牌',
        name: '无品牌',
        value: 0, // 0自定义,可自己填写内容；其他值则不可自己填写
        diy_type: 1, // 1自定义
        isDisabled: true, // true禁止编辑
    },
    '855': {
        property_name: '出版社名称',
        name: '豆包知道',
        value: 0,
        diy_type: 1,
        isDisabled: true, 
    },
    '449': {
        property_name: '作者',
        name: '豆包知道',
        value: 0,
        diy_type: 1,
        isDisabled: true, 
    },
    // 下面2024.10.15新添加
    '21': {
        property_name: '主讲老师',
        name: '豆包知道',
        value: '36476',
        diy_type: 0,
        isDisabled: true, 
    },
    '433': {
        property_name: '学习平台',
        name: '站外平台线上学习',
        value: '2681',
        diy_type: 1,
        isDisabled: true, 
    },
    '560': {
        property_name: '开课形式',
        name: '随到随学',
        value: '36476',
        diy_type: 1,
        isDisabled: true, 
    },
    '671': {
        property_name: '培训班类型',
        name: '录播课',
        value: '31161',
        diy_type: 0,
        isDisabled: true, 
    },
    '954': {
        property_name: '总课时',
        name: '总课时',
        value: 0,
        diy_type: 0,
        isDisabled: true, 
    },
    '2132': {
        property_name: '发货形式',
        name: '平台发码',
        value: '3899',
        diy_type: 1,
        isDisabled: true, 
    },
    '2778': {
        property_name: '教学形式',
        name: '线上录播',
        value: '32020',
        diy_type: 1,
        isDisabled: true, 
    },
    // 下面2024.11.11新添加
    '271': {
        property_name: '观看路径',
        name: 'http://a.doubao21.com/gm66j',
        value: 0,
        diy_type: 1,
        isDisabled: true, 
    },
}
/* 
    商品上传默认字段值:
    商品类型：虚拟商品
    品牌：无品牌 ✅
    出版社名称：豆包知道 ✅
    作者：豆包知道 ✅
    订单库存计数：下单减库存
    提取方式：使用电子交易凭证
    券码生成方式：第三方平台生成卡券
    售后退改规则：随时退&过期自动退
    可使用次数：1
    使用条件：须依据领取兑换使用券
    有效期：固定天数（30天）
    客服电话：18630754280
    领取须知：
        1、购买后可立即兑换使用
        2、仅支持券码在有效期内在豆包知道抖音小程序兑换使用
        3、券码有效时长为购买后30天，过期自动作废
        4、券码不支持多人使用，一人一码核销完成后自动失效
        5、到期如未核销使用，可支持退款
        6、核销完成后不支持无理由退款
    售后服务承诺：不包含
    商品状态：上架
    商品限购：每次限购1件
*/

export const otherInfoValidate = {
    '1618': [
        {validator: (rule, value, callback) => {
            console.log('otherInfoValidate-value:',value)
            if (value[0].name == '11') {
              callback(new Error('请再次输入密码'));
            }else {
              callback();
            }
        }, trigger: 'blur'}
    ]
}